import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../Button';
import { Grid } from '@material-ui/core';

const YesNoActions = ({ confirmText, declineText, confirm, decline }) => (
    <Grid container direction="row" justify="flex-end" alignItems="center">
        <Grid item>
            <Button
                onClick={decline}
                color="secondary"
                autoFocus
                variant="text"
            >
                {declineText}
            </Button>
        </Grid>
        <Grid item>
            <Button onClick={confirm} color="primary" variant="text">
                {confirmText}
            </Button>
        </Grid>
    </Grid>
);
export default YesNoActions;

YesNoActions.propTypes = {
    confirm: PropTypes.func.isRequired,
    confirmText: PropTypes.string,
    decline: PropTypes.func.isRequired,
    declineText: PropTypes.string,
};

YesNoActions.defaultProps = {
    confirmText: 'Ok',
    declineText: 'Cancel',
};
